<template>
<div class="md:flex flex-wrap min-h-screen">

  <!-- header -->
  <div class="bg-white md:fixed top-0 left-0 w-full h-20 flex items-center botborder z-10 relative">
    <img v-if="$store.state.dash.logoURL"  class="pt_logo w-48 block mx-auto" :src="$store.state.dash.logoURL"/>
    <img v-else  class="w-48 block mx-auto" src="@/assets/images/logo/logo.png"/>
  </div>

  <!-- inputs -->
  <div class="w-full py-6 md:pt-18 md:w-118 lg:w-200 bg-white md:shadow-setupside px-8 lg:px-24 min-h-full">
    <div>
    <h3 class="mt-10 mb-6 relative w-full font-medium pr-12 text-3xl lg:text-4xl inline-block">Start your free trial</h3>
    <p class="mb-6 mt-1"><span class="">✔️14 Day free-trial</span><span class="inline-block ml-3">✔️No card needed</span></p>
    <span v-if="registerErrorMsg" class="text-danger block my-6">{{ registerErrorMsg }}</span>
      <vs-input
        v-validate="'required|min:3|max:20'"
        data-vv-validate-on="blur"
        data-vv-as="First name"
        label="First Name"
        name="displayName"
        placeholder="John"
        v-model="displayName"
        class="w-full" />
        <span class="text-primary my-2">{{ errors.first('displayName') }}</span>

      <vs-input
        v-validate="'required|email|max:60'"
        data-vv-validate-on="blur"
        name="email"
        type="email"
        label="Email"
        placeholder="john@hancock.com"
        v-model="email"
        class="w-full mt-6" />
      <span class="text-primary">{{ errors.first('email') }}</span>

      <vs-input
        ref="password"
        type="password"        
        v-validate="'required|min:6|max:15'"
        name="password"
        label="Password"
        placeholder="Choose a password"
        @blur="checkPWAlpha"
        v-model="password"
        class="w-full mt-6" />
        <span class="text-primary">{{ errors.first('password') ? errors.first('password') : passwordMsg }}</span>
      <vs-button class="w-full font-semibold mt-8 mb-4 pmybtnshdw" size="large" @click="registerUser" :disabled="!validateForm">Get started!</vs-button>
      <p>By clicking this button, you agree to our <a href="https://feedback.link/tou.html" target="_blank">Terms</a> and <a href="https://feedback.link/privacy.html" target="_blank">Privacy Policy.</a></p>
      <p class="text-center mt-10">Already have an account?</p>
      <vs-button  type="flat" to="/pages/login" class="w-full my-2">< To Login</vs-button>

    </div>
  </div>

  <!-- aside -->
  <div class="w-full py-8 md:py-0 md:fixed md:w-full md:top-20 md:pl-118 lg:pl-200 md:pb-20 md:min-h-full z-m1 md:flex items-center icnbg" style="backgroundColor: #FBEFFF;">
    <div class="w-full px-2 text-center suaside text-dark lg:text-lg">
      <div >
        <div class="bgdiv">
        <img src="@/assets/images/misc/surs.png" class="w-16 block mx-auto"/>
        <p class="inline-block mx-auto tlblock pl text-lg font-semibold">✔️Reviews & Shares</p>
        <p class="block mx-auto font-medium  text-lg my-2" style="max-width: 20rem;">Generate online word of mouth. Turn customers into promoters.</p>
        <img class="w-64" src="@/assets/images/misc/reviewlogos.png"/>
        </div>
      </div>
      <div class="mt-10 lg:mt-16">
        <div class="bgdiv">
          <img src="@/assets/images/misc/susc.png" class="w-16 block mx-auto"/>
          <p class="inline-block mx-auto tlblock pi text-lg font-semibold font-medium">✔️Showcase</p>
          <p class="block mx-auto text-lg font-medium mt-2" style="max-width: 22rem;">Improve conversion on your website with Social Proof widgets.</p>
          </div>              
      </div>
      <div class="mt-12 lg:mt-20">
        <div class="bgdiv">
          <img src="@/assets/images/misc/sus.png" class="w-16 block mx-auto"/>
          <p class="inline-block mx-auto tlblock bl text-lg font-semibold font-medium">✔️Survey</p>
          <p class="block mx-auto text-lg font-medium mt-2" style="max-width: 24rem;">Discover new ideas and fresh perspectives through customer feedback.</p>
          </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>


function isAlphaNumeric(myString) {
  return (/\d/.test(myString) && (myString.match(/[a-z]/i)))
}

export default {
  data () {
    return {
      registerErrorMsg: false,
      displayName: '',
      email: '',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: true,
      passwordMsg: ''
    }
  },
  watch: {
    password() {
      this.passwordMsg = ''
    }
  },
  computed: {
    validateForm () {
      return this.passwordMsg === '' && !this.errors.any() && this.displayName !== '' && this.email !== '' && this.password !== '' && this.isTermsConditionAccepted === true
    }
  },
  methods: {
    checkPWAlpha () {
      if (this.password !== '') {
        if (!isAlphaNumeric(this.password)){
          this.passwordMsg = 'Your password should contain at least one number and one letter.'
        }
      }
    },
    setErrorMessage (msg){
      this.registerErrorMsg = msg
    },
    registerUser () {
      // If form is not validated or user is already login return

      this.$vs.loading()

      this.registerErrorMsg = false

      if (!this.validateForm) return

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/registerUser', payload).then(() => {

        this.$vs.loading.close()
        this.$router.push('/dash/setup')

      }).catch((e) => {

      this.$vs.loading.close()
      //noconsoleconsole.log(e)
      this.$vs.dialog({
        type: 'confirm',
        color: 'dark',
        acceptText: 'Ok',
        cancelText: 'To Login',
        title: `Create account`,
        text: 'We couldn\'t create your account with that email address, are you sure you\'re not already signed up?',
        cancel: () => {
          this.$router.push('/dash/login')
        }
      })

      })

    }
  }
}

</script>


<style lang="scss">

  .bgdiv {
      //background-color: #FBEFFF;
      display: inline-block;
      border-radius: 50px;
  }

  .tlblock {
    position: relative;
    z-index: 10;
    //top: -6px;
    //padding: 1px 4px;
    margin-top: 0.6rem;
    border-radius: 3px;
    &.pl {
      //background: #E5B7F4;
    }
    &.bl {
      //background: #CBB7F4;
    }
    &.pi {
      //background: #F0B7E7;
    }

  }




</style>
